import { computed } from "vue";
import useCreateComponentConfig from "../../../composables/useCreateComponentConfig.js";
import { EVariants } from "../types.js";
var EElements = /* @__PURE__ */ ((EElements2) => {
  EElements2["ROOT"] = "ROOT";
  EElements2["ICON"] = "ICON";
  return EElements2;
})(EElements || {});
export default function useConfig(props) {
  const rootClasses = useRootConfig(props);
  const iconClasses = useIconConfig(props);
  return {
    rootClasses,
    iconClasses
  };
}
function useRootConfig(props) {
  const { setBase, getClasses, addVariant } = useCreateComponentConfig();
  setBase(
    "ROOT" /* ROOT */,
    /* tw */
    `p-2 rounded-container-sm`
  );
  addVariant("ROOT" /* ROOT */, EVariants.NEUTRAL, {
    base: (
      /* tw */
      "bg-neutral-secondary"
    ),
    states: {}
  });
  addVariant("ROOT" /* ROOT */, EVariants.INFORMATIVE, {
    base: (
      /* tw */
      "bg-validation-informative-light"
    ),
    states: {}
  });
  addVariant("ROOT" /* ROOT */, EVariants.WARNING, {
    base: (
      /* tw */
      "bg-validation-warning-light"
    ),
    states: {}
  });
  addVariant("ROOT" /* ROOT */, EVariants.ERROR, {
    base: (
      /* tw */
      "bg-validation-danger-light"
    ),
    states: {}
  });
  addVariant("ROOT" /* ROOT */, EVariants.SUCCESS, {
    base: (
      /* tw */
      "bg-validation-success-light"
    ),
    states: {}
  });
  const classes = computed(() => {
    return getClasses("ROOT" /* ROOT */, props.variant, void 0, void 0, void 0);
  });
  return classes.value;
}
function useIconConfig(props) {
  const { getClasses, addVariant } = useCreateComponentConfig();
  addVariant("ICON" /* ICON */, EVariants.INFORMATIVE, {
    base: (
      /* tw */
      "text-validation-informative"
    ),
    states: {}
  });
  addVariant("ICON" /* ICON */, EVariants.WARNING, {
    base: (
      /* tw */
      "bg-validation-warning-bold"
    ),
    states: {}
  });
  addVariant("ICON" /* ICON */, EVariants.ERROR, {
    base: (
      /* tw */
      "text-validation-danger"
    ),
    states: {}
  });
  addVariant("ICON" /* ICON */, EVariants.SUCCESS, {
    base: (
      /* tw */
      "text-validation-success"
    ),
    states: {}
  });
  const classes = computed(() => {
    return getClasses("ICON" /* ICON */, props.variant, void 0, void 0, void 0);
  });
  return classes.value;
}
